import { Switch } from "react-router-dom";
import AdminLayout from "../layouts/DashboardAdmin/AdminLayout";


import AppRoute from "./AppRoute";
import Home from "../views/admin";
import TourismCategories from "../views/admin/tourism/categories";
import ChangePassword from "../views/auth/changePassword";
import { Redirect, Route } from "react-router-dom/cjs/react-router-dom";
import AdminHome from "../views/admin/AdminHome";
import AdminPlans from "../views/admin/subscriptions/AdminPlans";
import Products from "../views/company/products";
import ProductWizard from "../views/company/products/products/ProductWizard";
import ProductEditV2 from "../views/company/products/products/ProductEditV2";
import ProductUpdate from "../views/company/products/update";
import Categories from "../views/company/categories";
import CategoriesAdd from "../views/company/categories/add";
import CategoriesUpdate from "../views/company/categories/update";
import Attributes from "../views/company/products/attributes";
import AttributesCreate from "../views/company/products/attributes/create";
import AttributesValues from "../views/company/products/attributes/values";
import AttributesValuesCreate from "../views/company/products/attributes/values/create";
import AttributesValuesUpdate from "../views/company/products/attributes/values/update";
import ModifierGroups from "../views/company/products/modifierGroups";
import ModifierGroupsCreate from "../views/company/products/modifierGroups/create";
import ModifierGroupOptions from "../views/company/products/modifierGroups/options";
import ModifierOptionCreate from "../views/company/products/modifierGroups/options/create";
import ModifierOptionUpdate from "../views/company/products/modifierGroups/options/update";
import Orders from "../views/company/orders";
import OrderDetails from "../views/company/orders/details";
import SubscriptionsIndex from "../views/company/subscriptions";
import Plans from "../views/company/subscriptions/plans/Plans";
import PlanCreate from "../views/company/subscriptions/plans/PlanCreate";
import PlanEdit from "../views/company/subscriptions/plans/PlanEdit";
import PlanDetail from "../views/company/subscriptions/plans/PlanDetail";
import SubscriptionEnroll from "../views/company/subscriptions/subscriptions/SubscriptionEnroll";
import Employees from "../views/company/employees/Employees";
import AssociatesAdd from "../views/company/businessCards/add";
import BusinessCards from "../views/company/businessCards";
import Events from "../views/company/events";
import EventsAdd from "../views/company/events/add";
import EventsUpdate from "../views/company/events/update";
import EventTabs from "../views/company/events/event";
import Sponsors from "../views/company/events/sponsors";
import SponsorAdd from "../views/company/events/sponsors/add";
import Ticket from "../views/client/events/ticket";
import AssetsManager from "../views/company/assets/AssetsManager";
import ResourceLinker from "../views/company/assets/ResourceLinker";
import MerchantReservationsPage from "../views/company/bookings/ReservationsPage";





export default function AdminNavigation()
{
    return(
        <Switch>
            <AppRoute exact path='/' layout={AdminLayout} component={AdminHome} />

            <AppRoute exact path='/admin/plans' layout={AdminLayout} component={AdminPlans} />

            {/**SETTINGS */}
            <AppRoute exact path='/settings' layout={AdminLayout} component={Home} />
            <AppRoute exact path='/settings/tourism/categories' layout={AdminLayout} component={TourismCategories} />


            <AppRoute exact path='/products' layout={AdminLayout} component={Products} />
            {/*<AppRoute exact path='/products/create' layout={AdminLayout} component={ProductCreate} />*/}
            <AppRoute exact path='/products/create' layout={AdminLayout} component={ProductWizard} />
            <AppRoute exact path='/products/edit/:id' layout={AdminLayout} component={ProductEditV2} />
            <AppRoute exact path='/products/update' layout={AdminLayout} component={ProductUpdate} />

            <AppRoute exact path='/products/categories' layout={AdminLayout} component={Categories} />
            <AppRoute exact path='/products/categories/add' layout={AdminLayout} component={CategoriesAdd} />
            <AppRoute exact path='/products/categories/update' layout={AdminLayout} component={CategoriesUpdate} />

            <AppRoute exact path='/products/attributes' layout={AdminLayout} component={Attributes} />
            <AppRoute exact path='/products/attributes/create' layout={AdminLayout} component={AttributesCreate} />
            <AppRoute exact path='/products/attributes/update/:id' layout={AdminLayout} component={AttributesCreate} />
            <AppRoute exact path='/products/attributes/values/:attributeId' layout={AdminLayout} component={AttributesValues} />
            <AppRoute exact path='/products/attributes/values/:attributeId/:attributeName/create' layout={AdminLayout} component={AttributesValuesCreate} />
            <AppRoute exact path='/products/attributesValues/update/:attributeValueId' layout={AdminLayout} component={AttributesValuesUpdate} />
            <AppRoute exact path='/products/modifiergroups' layout={AdminLayout} component={ModifierGroups} />
            <AppRoute exact path='/products/modifiergroups/create' layout={AdminLayout} component={ModifierGroupsCreate} />
            <AppRoute exact path='/products/modifiergroups/options/:modifierGroupId' layout={AdminLayout} component={ModifierGroupOptions} />
            <AppRoute exact path='/products/modifiergroups/options/:modifierGroupId/create' layout={AdminLayout} component={ModifierOptionCreate} />
            <AppRoute exact path='/products/modifiers/update/:modifierId' layout={AdminLayout} component={ModifierOptionUpdate} />

            <AppRoute exact path='/orders' layout={AdminLayout} component={Orders} />
            <AppRoute exact path='/orders/details/:code' layout={AdminLayout} component={OrderDetails} />

            {/**Bookings */}
            <AppRoute exact path='/assets' layout={AdminLayout} component={AssetsManager} />
            <AppRoute exact path='/assets/linker' layout={AdminLayout} component={ResourceLinker} />


            {/** SUBSCRIPTIONS */}
            <AppRoute exact path='/subscriptions' layout={AdminLayout} component={SubscriptionsIndex} />
            <AppRoute exact path='/subscriptions/plans' layout={AdminLayout} component={Plans} />
            <AppRoute exact path='/subscriptions/plans/create' layout={AdminLayout} component={PlanCreate} />
            <AppRoute exact path='/subscriptions/plans/edit/:id' layout={AdminLayout} component={PlanEdit} />
            <AppRoute exact path='/subscriptions/plans/detail/:id' layout={AdminLayout} component={PlanDetail} />
            <AppRoute exact path='/subscriptions/enroll/:planId' layout={AdminLayout} component={SubscriptionEnroll} />


            <AppRoute exact path='/employees' layout={AdminLayout} component={Employees} />
            <AppRoute exact path='/associates/add' layout={AdminLayout} component={AssociatesAdd} />

            <AppRoute exact path='/businesscard/:uuid' layout={AdminLayout} component={BusinessCards} />

            <AppRoute exact path='/events' layout={AdminLayout} component={Events} />
            <AppRoute exact path='/events/add' layout={AdminLayout} component={EventsAdd} />
            <AppRoute exact path='/events/update/:id' layout={AdminLayout} component={EventsUpdate} />

            <AppRoute exact path='/events/event/:id' layout={AdminLayout} component={EventTabs} />

            <AppRoute exact path='/events/sponsors/:id' layout={AdminLayout} component={Sponsors} />
            <AppRoute exact path='/events/sponsors/:id/add' layout={AdminLayout} component={SponsorAdd} />
            <AppRoute exact path='/ticketing/:uuid' layout={AdminLayout} component={Ticket} />

            {/**Reservations */}
            <AppRoute exact path='/reservations' layout={AdminLayout} component={MerchantReservationsPage} />



            {/**SECURITY */}
            <AppRoute exact path='/security/changepassword' layout={AdminLayout} component={ChangePassword} />

            {/**Para las rutas no encontradas */}
            <Route path="*">
                <Redirect path="/"/>
            </Route>
        </Switch>
    )
}